import { render, staticRenderFns } from "./tab-disabled.vue?vue&type=template&id=2b491c25"
import script from "./tab-disabled.vue?vue&type=script&lang=js"
export * from "./tab-disabled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports